( function ( $ ) {

	MP.aboutCounter = function(){

		var $counters = $('.anicount');

		var globalMax = [];

		$counters.each(function(){
			globalMax.push($(this).data('count'));
		});
		
		globalMax = Math.max.apply(null, globalMax);
		
		$counters.each(function(){
			
			const $item = $(this);

			var n = 0,
				max = $item.data('count'),
				speed = globalMax / max;
		
			var interval;
			function count(){
				if(lib.isScrolledIntoView($item[0])){
					interval = setInterval(function(){
						if (n < max){
							n++;
						} else {
							clearInterval( interval );
						}
						$item.text(  n.commaSep() );
						
					},speed );
				}
			}
			
			count();

			window.addEventListener('scroll', count);

		});
	};

}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/m-home-about.js